export default __webpack_public_path__ + "static/media/banner-bg.79058cee.svg";